import { Injectable } from '@angular/core';
import { TalentPool } from 'mojo-talent-pools';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidenavNavigationService {
  isOpen = false;

  // To Update Talent Pool's statuses data on candidate's card menu
  private _talentPoolUpdate$ = new BehaviorSubject<TalentPool | null>(null);
  talentPoolUpdate$ = this._talentPoolUpdate$.asObservable();

  emitTalentPoolUpdate(talentPool: TalentPool) {
    this._talentPoolUpdate$.next(talentPool);
  }
}
